import {
  BarChart3, BookOpen, Building2, LayoutGrid, MapPin, Route, Settings, UserRound, Users, type LucideIcon,
} from '../ui/Icon';

export interface NavItem {
  to: string;
  icon: LucideIcon;
  labelKey: string;
}

export interface ModeNav {
  main: NavItem[];
  footer: NavItem[];
}

const DOCS: NavItem = { to: '/docs', icon: BookOpen, labelKey: 'nav.docs' };

/** Every agency screen is one entry: the desktop sidebar and the phone menu list the same. */
export function agencyNavItems(agencyId: string): ModeNav {
  const base = `/agency/${agencyId}`;
  return {
    main: [
      { to: '/dashboard', icon: LayoutGrid, labelKey: 'nav.agencyHome' },
      { to: `${base}/trips`, icon: MapPin, labelKey: 'agency.panel.tabs.current' },
      { to: `${base}/templates`, icon: Route, labelKey: 'agency.panel.tabs.templates' },
      { to: `${base}/clients`, icon: UserRound, labelKey: 'agency.panel.tabs.clients' },
      { to: `${base}/team`, icon: Users, labelKey: 'agency.panel.tabs.team' },
      { to: `${base}/settings`, icon: Settings, labelKey: 'agency.panel.tabs.settings' },
    ],
    footer: [DOCS],
  };
}

/** Gromly's administration: the same sidebar, its own screens. */
export const ADMIN_NAV: ModeNav = {
  main: [
    { to: '/dashboard', icon: LayoutGrid, labelKey: 'admin.nav.overview' },
    { to: '/admin/users', icon: Users, labelKey: 'admin.nav.users' },
    { to: '/admin/agencies', icon: Building2, labelKey: 'admin.nav.agencies' },
    { to: '/admin/metrics', icon: BarChart3, labelKey: 'admin.nav.usage' },
  ],
  footer: [DOCS],
};
